<template>
  <div>
    <div class="bi-delay-table ob-scroll" v-if="delayInfo.length">
      <table class="table table-striped table-condensed ob-scroll">
        <thead>
          <tr>
            <th>No</th>
            <th>DEP</th>
            <th>ARR</th>
            <th>Date</th>
            <th>Ground</th>
            <th>STD</th>
            <th>STA</th>
            <th>PSF</th>
            <th>FSF</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in delayInfo" :key="item.id">
            <td>{{ item.flightNumber }}</td>
            <td>{{ item.departure }}</td>
            <td>{{ item.arrival }}</td>

            <td>{{ item.date | formatDateWithoutHours }}</td>
            <td>{{ item.ground | formatTime }}</td>

            <td>{{ item.std | formatTime }}</td>
            <td>{{ item.sta | formatTime }}</td>

            <td>{{ item.psf }}</td>
            <td>{{ item.fsf }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="p-2" v-else>
      No affected flights
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { BoardItemDelayItemInfo } from '@/types/boardItemDelayInfo';

  @Component({})
  export default class BoardItemDelayInfo extends Vue {
    @Prop() value: any;

    get delayInfo() {
      return this.value && this.value.length ? (this.value as BoardItemDelayItemInfo[]) : [];
    }
  }
</script>

<style scoped lang="scss">
  .bi-delay-table {
    font-size: 10px;
    overflow-y: auto;

    margin-right: -15px;
    margin-left: -15px;

    table {
      th {
        margin: 0 10px;
      }

      td {
        padding: 4px 10px;
      }
    }
  }

  .ob-scroll::-webkit-scrollbar {
    height: 8px;
  }
</style>
